import * as Models from "../models";
import { QALineInfo, LeagueInfo, BranchInfo, DataHelper } from "sb-resp-lib";
import { RacingEventTypes } from "../enums";

/* TODO(developer): refactor to lower cyclomatic complexity */
/* tslint:disable:cyclomatic-complexity */

export class Parser {

    public static RacingMasterEventParse(initArray: any[]): Models.RacingMasterEventInfo {

        let parsedRacingEvents = new Array<Models.RacingEventInfo>();
        let racecardUrl = "";
        if (Array.isArray(initArray[2])) {
            for (let value of initArray[2]) {
                let currEvent = this.RacingEventParse(value);
                parsedRacingEvents.push(currEvent);
                racecardUrl = parseInt(currEvent.typeId) === RacingEventTypes.RaceCard ? currEvent.urlCode : racecardUrl;
            }
        }

        var hasRacingEvents = parsedRacingEvents.find((ev) => {
            return parseInt(ev.typeId) === RacingEventTypes.RaceCard || ev.raceProgress === 2;
        });

        let date = Date.fromISO(initArray[1].toString()) || new Date();
        date = DataHelper.getUkTime(date);

        return new Models.RacingMasterEventInfo({
            id: initArray[0].toString(),
            date,
            racingEvents: parsedRacingEvents,
            masterLeagueId: initArray[3],
            raceProgress: hasRacingEvents ? parsedRacingEvents[0].raceProgress : 0,
            hasLiveStream: hasRacingEvents ? hasRacingEvents.hasLiveStream : false,
            url: racecardUrl
        });
    }

    /* istanbul ignore next */
    public static RacingEventParse(initArray: any[]): Models.RacingEventInfo {

        var lines = new Array<QALineInfo>();
        if (Array.isArray(initArray[2])) {
            for (let value of initArray[2]) {
                let currLine = this.QaLineParse(value);
                lines.push(currLine);
            }
        }
        var racecardLines = new Array<Models.RacecardLineInfo>();

        if (Array.isArray(initArray[12])) {
            for (let value of initArray[12]) {
                let currLine = this.RacecardLineParse(value);
                racecardLines.push(currLine);
            }
        }

        let date;

        if (initArray[5]) {
            date = Date.fromISO(initArray[5].toString());
        }
        else {
            date = new Date();
        }

        date = DataHelper.getUkTime(date);

        return new Models.RacingEventInfo({
            id: initArray[0],
            typeId: initArray[1],
            lines,
            eventName: initArray[3],
            date,
            isEachWayEnabled: parseInt(initArray[9]) === 1,
            hasLiveStream: parseInt(initArray[9]) === 1,
            ewPlaceTerms: initArray[10],
            ewOddsTerms: initArray[11],
            racingStateId: parseInt(initArray[12]),
            raceProgress: initArray[13],
            tricastEnabled: parseInt(initArray[15]) === 1,
            forecastEnabled: parseInt(initArray[16]) === 1,
            forecastMaxBet: parseInt(initArray[17]),
            branchId: initArray[19],
            feedEventId: initArray[20],
            feedProviderId: initArray[24],
            masterLeagueId: initArray[21],
            urlCode: initArray[25],
            leagueId: initArray[11],
            racecardLines
        });
    }

    public static RacingEventParseUpdateEvents(initArray: any[]): Models.RacingEventInfo {

        var lines = new Array<QALineInfo>();
        if (Array.isArray(initArray[2])) {
            for (let value of initArray[2]) {
                let currLine = this.QaLineParse(value);
                lines.push(currLine);
            }
        }
        var racecardLines = new Array<Models.RacecardLineInfo>();

        if (Array.isArray(initArray[12])) {
            for (let value of initArray[12]) {
                let currLine = this.RacecardLineParse(value);
                racecardLines.push(currLine);
            }
        }

        let date;

        if (initArray[6]) {
            date = Date.fromISO(initArray[6].toString());
        }
        else {
            date = new Date();
        }

        date = DataHelper.getUkTime(date);

        return new Models.RacingEventInfo({
            id: initArray[0],
            typeId: initArray[1],
            lines,
            eventName: initArray[3],
            date,
            isEachWayEnabled: parseInt(initArray[9]) === 1,
            hasLiveStream: parseInt(initArray[9]) === 1,
            ewPlaceTerms: initArray[10],
            ewOddsTerms: initArray[11],
            racingStateId: parseInt(initArray[19]),
            raceProgress: initArray[13] || -1,
            tricastEnabled: parseInt(initArray[15]) === 1,
            forecastEnabled: parseInt(initArray[16]) === 1,
            forecastMaxBet: parseInt(initArray[17]),
            branchId: initArray[19],
            feedEventId: initArray[20],
            feedProviderId: initArray[24],
            masterLeagueId: initArray[21],
            urlCode: initArray[25],
            leagueId: initArray[11],
            racecardLines
        });
    }

    /* istanbul ignore next */
    public static QaLineParse(initArray: any[]): QALineInfo {

        return new QALineInfo({
            id: initArray[0],
            odds: parseInt(initArray[1]),
            lineName: initArray[2],
            lineTypeId: initArray[3],
            fractOddsDividend: parseInt(initArray[5]),
            fractOddsDivisor: parseInt(initArray[6]),
            lineStateId: parseInt(initArray[7]),
            lineTypeName: initArray[8],
            qaParameter2: parseInt(initArray[9]),
            qaParameter1: parseInt(initArray[10]),
            feedSelectionId: initArray[13]
        });
    }
    /* istanbul ignore next */
    public static RacecardLineParse(initArray: any[]): Models.RacecardLineInfo {

        return new Models.RacecardLineInfo({
            lineId: initArray[0],
            competitorName: initArray[1],
            trainer: initArray[3],
            jockey: initArray[4],
            stall: parseInt(initArray[5]),
            date: new Date(initArray[6]),
            competitorNumber: parseInt(initArray[7]),
            qaEventId: initArray[14],
            leagueId: initArray[15],
            rule4Deduction: initArray[16],
            rpr: initArray[17],
            diomedComment: initArray[18],
            silkData: initArray[19]
        });
    }

    public static RegionParse(initArray: any[]): Models.RacingRegionInfo {

        return new Models.RacingRegionInfo({
            id: parseInt(initArray[0]),
            name: initArray[1],
            hasEvents: parseInt(initArray[2]) === 1
        });
    }

    public static LeagueParse(initArray: any[]): LeagueInfo {

        return new LeagueInfo({
            id: initArray[0],
            name: initArray[1],
            sortId: parseInt(initArray[2]),
            rankId: parseInt(initArray[3]),
            masterLeagueId: initArray[20],
            urlCode: initArray[24],
            countryName: initArray[19]
        });
    }

    public static BranchParse(initArray: any[]): BranchInfo {

        return new BranchInfo({
            id: initArray[0],
            name: initArray[1],
            sortId: parseInt(initArray[2]),
            code: initArray[3]
        });
    }

    public static RacingResultInfoParse(initArray: any[]): Models.RacingResultInfo {

        var lines = new Array<Models.RacingResultLine>();
        var withdrawnLines = new Array<Models.RacingResultLine>();

        /* istanbul ignore next */
        if (Array.isArray(initArray[12])) {
            for (let value of initArray[12]) {
                let currLine = this.RacingResultLineParse(value);
                lines.push(currLine);
            }
        }

        /* istanbul ignore next */
        if (Array.isArray(initArray[13])) {
            for (let value of initArray[13]) {
                let currLine = this.RacingResultLineParse(value);
                withdrawnLines.push(currLine);
            }
        }

        return new Models.RacingResultInfo({
            id: initArray[0],
            eventName: initArray[1],
            eventDate: new Date(initArray[2]),
            eachWayTerms: initArray[3],
            leagueId: initArray[4],
            masterLeagueName: initArray[5],
            masterLeagueId: initArray[6],
            foreCastDividents: initArray[7],
            triCastDividents: initArray[8],
            foreCast: initArray[9],
            triCast: initArray[10],
            countryId: initArray[11],
            branchId: initArray[14],
            lines,
            withdrawnLines
        });
    }

    /* istanbul ignore next */
    public static RacingResultLineParse(initArray: any[]): Models.RacingResultLine {

        return new Models.RacingResultLine({
            id: initArray[0],
            competitorName: initArray[1],
            result: parseInt(initArray[2]),
            raceCardNum: parseInt(initArray[3]),
            dividend: parseInt(initArray[4]),
            divisor: parseInt(initArray[5]),
            percentDeduction: parseInt(initArray[6]),
            withdrawnTime: new Date(initArray[7]),
            leagueId: initArray[8],
            eventId: initArray[9],
            rule4Deduction: initArray[10],
            favorite: initArray[11],
            isWithdrawn: parseInt(initArray[12]) === 1,
            masterLeagueId: initArray[15]
        });
    }
}